import * as actionTypes from "../actionTypes";

const initialState = {
    categoryData: [],
};

const categoryReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_CATEGORY: {
            return {
                ...state,
                categoryData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default categoryReducer;
